import React, { useState, Suspense, lazy } from 'react';
import MicroFrontendError from '../errors/MicroFrontendError';
import LoadingScreen from '../loading/LoadingScreen';

// Dynamically load the micro-test app using Module Federation
const MicroTestApp = lazy(() => import('microTest/App'));

const MicroTestPage = () => {
  const [key, setKey] = useState(0);

  const handleRetry = () => {
    setKey(prev => prev + 1);
  };

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <React.Suspense
        key={key}
        fallback={<LoadingScreen message="Loading Micro Test Application..." />}
      >
        <ErrorBoundary
          fallback={<MicroFrontendError name="Micro Test" onRetry={handleRetry} />}
        >
          <MicroTestApp />
        </ErrorBoundary>
      </React.Suspense>
    </div>
  );
};

// Error boundary for catching micro-frontend errors
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Micro-frontend error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default MicroTestPage;
